import queryString from 'query-string';

export const getURLQueryString = (location, name) => {
  if (!location || !location.search) return null;

  const urlParams = queryString.parse(location.search);
  return urlParams[name];
};
